import { h } from '@stencil/core';

import wcShared from '@web-components/shared';

import { SwissBackupStorage } from '../../../../../../utils/enum';
import { InitStore } from '../../../../../../utils/Stores/init-store';
import { Store } from '../../../../../../utils/Stores/store';

export function getSwissBackupFields(
  checkEmptyField: boolean,
  changeData: (event: Event, value: string) => void,
) {
  return (
    <div>
      {/* Select product list */}
      <select
        class={{
          'no-margin-bottom':
            (Store?.get('messageData')?.swiss_backup_product === null ||
              Store?.get('messageData')?.swiss_backup_product === '') &&
            checkEmptyField,
        }}
        onChange={(event) => changeData(event, 'swiss_backup_product')}
      >
        <option
          value=""
          selected
          disabled
          hidden
        >
          {wcShared?.translate('Produit concerne')}
        </option>
        {InitStore?.get('init')?.environment?.swiss_backup.map((option) => {
          return <option value={option.name}>{option.name}</option>;
        })}
      </select>
      <span
        class={{
          'required-field': true,
          hide:
            (Store?.get('messageData')?.swiss_backup_product !== null &&
              Store?.get('messageData')?.swiss_backup_product !== '') ||
            !checkEmptyField,
        }}
      >
        {wcShared?.translate('*Champ obligatoire')}
      </span>

      {/* Button choice storage */}
      <div
        class={{
          question: true,
          'no-margin-bottom':
            (Store?.get('messageData')?.swiss_backup_storage === null ||
              Store?.get('messageData')?.swiss_backup_storage === '') &&
            checkEmptyField,
        }}
      >
        <div class="question__title">
          {wcShared?.translate("Merci d'indiquer le type d'espace de sauvegarde concerne :")}
        </div>
        <div class="question__choice">
          <button
            class={{
              'question__choice--2': true,
              selected: Store?.get('messageData').swiss_backup_storage === SwissBackupStorage.cloud,
            }}
            onClick={(e: Event) => changeData(e, SwissBackupStorage.cloud)}
          >
            {wcShared?.translate('Cloud (FTP/Swift/S3)')}
          </button>
          <button
            class={{
              'question__choice--1': true,
              selected:
                Store?.get('messageData').swiss_backup_storage === SwissBackupStorage.acronis,
            }}
            onClick={(e: Event) => changeData(e, SwissBackupStorage.acronis)}
          >
            {wcShared?.translate('Acronis')}
          </button>
        </div>
      </div>
      <span
        class={{
          'required-field': true,
          hide:
            (Store?.get('messageData')?.swiss_backup_storage !== null &&
              Store?.get('messageData')?.swiss_backup_storage !== '') ||
            !checkEmptyField,
        }}
      >
        {wcShared?.translate('*Champ obligatoire')}
      </span>

      {/* Select device only for cloud */}
      {Store?.get('messageData')?.swiss_backup_product !== null &&
        Store?.get('messageData')?.swiss_backup_storage === SwissBackupStorage.cloud &&
        InitStore?.get('init')?.environment?.swiss_backup.find(
          (product: IWCSwissBackupEnvironment) =>
            product.name === Store?.get('messageData')?.swiss_backup_product,
        )?.cloud_slots?.length > 0 && (
          <div>
            <select
              class={{
                'no-margin-bottom':
                  (Store?.get('messageData')?.swiss_backup_slot_cloud === null ||
                    Store?.get('messageData')?.swiss_backup_slot_cloud === '') &&
                  checkEmptyField,
              }}
              onChange={(event) => changeData(event, 'swiss_backup_slot_cloud')}
            >
              <option
                value=""
                selected
                disabled
                hidden
              >
                {wcShared?.translate('Appareil concerne')}
              </option>
              {InitStore?.get('init')
                ?.environment?.swiss_backup.find(
                  (product: IWCSwissBackupEnvironment) =>
                    product.name === Store?.get('messageData')?.swiss_backup_product,
                )
                ?.cloud_slots.map((option) => <option value={option}>{option}</option>)}
            </select>
            <span
              class={{
                'required-field': true,
                hide:
                  (Store?.get('messageData')?.swiss_backup_slot_cloud !== null &&
                    Store?.get('messageData')?.swiss_backup_slot_cloud !== '') ||
                  !checkEmptyField,
              }}
            >
              {wcShared?.translate('*Champ obligatoire')}
            </span>
          </div>
        )}

      {/* Input user/device only for acronis */}
      {Store?.get('messageData')?.swiss_backup_storage === SwissBackupStorage.acronis && (
        <div>
          <input
            type="text"
            onKeyPress={(e) => {
              e.stopPropagation();
            }}
            onKeyDown={(e) => {
              e.stopPropagation();
            }}
            onKeyUp={(e) => {
              e.stopPropagation();
            }}
            class={{
              'input-app-version': true,
              'no-margin-bottom':
                (Store?.get('messageData')?.swiss_backup_acronis_device === null ||
                  Store?.get('messageData')?.swiss_backup_acronis_device === '') &&
                checkEmptyField,
            }}
            placeholder={wcShared?.translate('Utilisateur ou appareil concerne')}
            value={Store?.get('messageData')?.swiss_backup_acronis_device}
            onInput={(event) => changeData(event, 'swiss_backup_acronis_device')}
            required
          />
          <span
            class={{
              'required-field': true,
              hide:
                (Store?.get('messageData')?.swiss_backup_acronis_device !== null &&
                  Store?.get('messageData')?.swiss_backup_acronis_device !== '') ||
                !checkEmptyField,
            }}
          >
            {wcShared?.translate('*Champ obligatoire')}
          </span>
        </div>
      )}
    </div>
  );
}
